"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _globalTooltipDelay = require("../../utils/globalTooltipDelay");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SourceListItemCtaIcons = require("./SourceListItemCtaIcons.styled");
var _SourcePdfAssignControl = require("./SourcePdfAssignControl.styled");
var SourcePdfAssignControl = function SourcePdfAssignControl(_ref) {
  var value = _ref.value,
    onPdfAssignClicked = _ref.onPdfAssignClicked;
  var targetElementId = 'pdf-assign-wrapper';
  var speakersUserIdsLength = value.speakerUserIds ? value.speakerUserIds.length : 0;
  var tooltipMessage = "".concat(speakersUserIdsLength, " Assigned Speaker").concat(speakersUserIdsLength > 1 ? 's' : '');
  return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
    id: targetElementId
  }, /*#__PURE__*/_react["default"].createElement(_SourcePdfAssignControl.CircleIconContainer, {
    onClick: onPdfAssignClicked,
    "data-testid": "assign-pdf-source",
    hasSpeakers: speakersUserIdsLength > 0
  }, /*#__PURE__*/_react["default"].createElement(_SourcePdfAssignControl.StyledIcon, {
    icon: speakersUserIdsLength > 0 ? _freeSolidSvgIcons.faUserCheck : _freeSolidSvgIcons.faUserPlus
  })), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    placement: 'top',
    delay: _globalTooltipDelay.TOOL_TIP_DELAY,
    target: targetElementId,
    message: tooltipMessage
  }));
};
SourcePdfAssignControl.propTypes = {
  sourceId: _propTypes["default"].string,
  type: _propTypes["default"].string,
  value: _propTypes["default"].object,
  onPdfAssignClicked: _propTypes["default"].func
};
var _default = exports["default"] = SourcePdfAssignControl;